export default class DownloadIcal {
  constructor(id) {
    this.data = {
      action: 'event_download_ical',
      nonce: window.wp_variables.ajax_nonce,
      post_id: window.wp_variables.current_post_id,
    };

    this.button = document.getElementById( id );

    if (!this.button) {
      return;
    }

    this.button.addEventListener( 'click', () => this.download() );
  }

  download() {
    this.button.classList.add( 'btn--loading' );
    this.button.classList.remove( 'btn--hide-icon' );
    this.button.disabled = true;

    fetch( window.wp_variables.ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams( this.data ).toString()
    } )
      .then( response => response.json() )
      .then( response => {
        if (!!response.success) {
          // Create a Blob from the iCalendar content.
          const blob = new Blob( [response.data.content], {type: 'text/calendar'} );

          // Create a download link.
          const downloadLink = document.createElement( 'a' );
          downloadLink.href = URL.createObjectURL( blob );
          downloadLink.download = response.data.filename;

          // Append the link to the body
          document.body.appendChild( downloadLink );

          // Trigger the click event to start the download.
          downloadLink.click();

          // Remove the link from the document like it never existed.
          document.body.removeChild( downloadLink );
        } else {
          throw new Error( response.data?.message );
        }
      } )
      .finally( () => {
        this.button.disabled = false;
        this.button.classList.remove( 'btn--loading' );
        this.button.classList.add( 'btn--hide-icon' );
      } )
      .catch( error => console.error( 'AJAX error:', error ) );
  }
}
